/**
 * Industry categories based on LinkedIn Industry Codes V2
 * Reference: https://learn.microsoft.com/en-us/linkedin/shared/references/reference-tables/industry-codes-v2
 * Keep this consistent with backend categories in vendor-profiles.ts
 */
export const VENDOR_INDUSTRIES = [
  'Accommodation Services',
  'Administrative and Support Services',
  'Agriculture, Forestry, Fishing and Hunting',
  'Arts, Entertainment, and Recreation',
  'Construction',
  'Consumer Services',
  'Education',
  'Energy, Mining and Utilities',
  'Financial Services',
  'Government Administration',
  'Health Care and Social Assistance',
  'Information Technology and Services',
  'Legal Services',
  'Manufacturing',
  'Media and Communications',
  'Non-profit Organization Management',
  'Professional Services',
  'Public Safety',
  'Real Estate',
  'Retail',
  'Transportation, Logistics, Supply Chain and Storage',
  'Wellness and Fitness Services',
  'Wholesale Trade'
] as const

export type VendorIndustry = typeof VENDOR_INDUSTRIES[number]

/**
 * Industry subcategories for more specific categorization
 * Based on LinkedIn's hierarchical structure
 */
export const VENDOR_INDUSTRY_SUBCATEGORIES: Record<string, string[]> = {
  'Information Technology and Services': [
    'Computer Software',
    'Computer Hardware',
    'Computer Networking',
    'Internet',
    'Information Services',
    'Wireless'
  ],
  'Professional Services': [
    'Management Consulting',
    'Human Resources',
    'Marketing and Advertising',
    'Public Relations and Communications',
    'Design',
    'Translation and Localization',
    'Market Research',
    'Events Services'
  ],
  'Financial Services': [
    'Banking',
    'Investment Banking',
    'Investment Management',
    'Insurance',
    'Accounting',
    'Financial Services'
  ],
  'Manufacturing': [
    'Automotive',
    'Machinery',
    'Electrical/Electronic Manufacturing',
    'Food & Beverages',
    'Textiles',
    'Chemicals',
    'Plastics'
  ],
  'Health Care and Social Assistance': [
    'Hospital & Health Care',
    'Medical Practice',
    'Mental Health Care',
    'Medical Devices',
    'Pharmaceuticals',
    'Biotechnology'
  ],
  'Construction': [
    'Construction',
    'Architecture & Planning',
    'Civil Engineering',
    'Building Materials'
  ],
  'Education': [
    'Higher Education',
    'Primary/Secondary Education',
    'Education Management',
    'E-Learning',
    'Research'
  ],
  'Media and Communications': [
    'Online Media',
    'Broadcast Media',
    'Publishing',
    'Telecommunications',
    'Wireless'
  ]
}
